import Vue from 'vue'
import Cookies from 'js-cookie'
import { desktopInvalidTokenCheckAndHandler } from './desktopInvalidTokenCheckAndHandler'
import {v1 as uuidv1} from 'uuid'

export interface IReport {
  applicationId: 'PC',
  locale: string
  bizType: 'LIVENESS_DETECTION_PC'
  info: {
    browserInfo: {
      userAgent: string,
    }
    detail: IReportDetail,
  }
  sdkVersion: string
  eventType: string
  eventTimestamp: number
  eventCostInMilliSeconds: number,
}

export interface IReportDetail {
  reportUuid?: string,
  userId?: string,

  state?: 'RESOLVE' | 'UPLOAD',
  result?: boolean,
  message?: string,

  videoFileFullName?: string,
  videoDuration?: number,

  videoOrigFormat?: string,
  videoOrigSize?: number,
  videoOrigWidth?: number,
  videoOrigHeight?: number,

  isResolved?: boolean,
  resolveType?: string,
  resolveTime?: number,
  videoResolvedFormat?: string,
  videoResolvedSize?: number,
  videoResolvedWidth?: number,
  videoResolvedHeight?: number,

  uploadTime?: number,
  transactionId?: string,
  score?: number,
  tryCount?: number,
  returnUrl?: string,
  failedReturnUrl?: string
}

function getReportUuid() {
  if (Cookies.get('REPORT_UUID')) {
    return Cookies.get('REPORT_UUID')
  }
  Cookies.set('REPORT_UUID', uuidv1())
  return Cookies.get('REPORT_UUID')
}

export function getReport(): IReport {
  return {
    applicationId: 'PC',
    locale: navigator.language,
    bizType: 'LIVENESS_DETECTION_PC',
    info: {
     browserInfo: {
        userAgent: navigator.userAgent,
      },
      detail: {
        reportUuid: getReportUuid(),
      },
    },
    sdkVersion: process.env.VERSION || '',
    eventType: 'REPORT',
    eventTimestamp: -1,
    eventCostInMilliSeconds: -1,
  }
}

export async function sendReport(report: IReport) {
  try {
    const { data: { code } } = await Vue.prototype.$http.post('/openapi/side/v1/event-tracking', report)
    // desktopInvalidTokenCheckAndHandler(code)
  } catch (e) {
    console.log('report error', report, e)
  }
}
